const metadata = {
  title: 'James Lin',
  description: 'Full-stack Developer Portfolio',
  author: 'James Lin',
  lang: 'en',
  url: 'https://jameslin.me',
};

export default metadata;
